<template>
  <span class="d-none">
    <button v-if="bgClass=='bg-default'" @click="changeBackground('bg-bananas')" class="btn btn-secondary">
      <img height="20" src="@/assets/img/icons/minion.svg">
      <small class="ml-2">{{ $t('components.backgroundChanger.buttons.bananas') }}</small>
    </button>

    <button v-if="bgClass=='bg-bananas'" @click="changeBackground('bg-default')" class="btn btn-secondary">
      <img height="20" src="@/assets/img/icons/minion.svg">
      <small class="ml-2">{{ $t('components.backgroundChanger.buttons.getSerious') }}</small>
    </button>
  </span>
</template>

<script>
  export default {
    name: "BackgroundChanger",
    computed: {
      bgClass: function() { return this.$store.state.settings.backgroundClass }
    },
    mounted: function() {
      document.body.className = this.$store.state.settings.backgroundClass
    },
    methods: {
      changeBackground: function(bgClass) {
        this.$store.commit('setBackgroundClass', bgClass)
        document.body.className = bgClass
      }
    }
  }
</script>

<style scoped>

</style>
